export const i18nMap: Record<string, { en: string; it: string }> = {
  i18n_GOOGLEADS_AUTH_TITLE: {
    en: 'Google Ads Authentication',
    it: 'Autenticazione Google Ads',
  },
  i18n_GOOGLEADS_AUTH_DESCRIPTION: {
    en: 'Connect your Google Ads account to sync customer match audiences',
    it: 'Collega il tuo account Google Ads per sincronizzare le audience di customer match',
  },
  i18n_GOOGLEADS_AUTH_CONNECTION_NAME_TITLE: {
    en: 'Connection Name',
    it: 'Nome Connessione',
  },
  i18n_GOOGLEADS_AUTH_CONNECTION_NAME_DESCRIPTION: {
    en: 'A friendly name to identify this Google Ads connection',
    it: 'Un nome descrittivo per identificare questa connessione Google Ads',
  },
  i18n_GOOGLEADS_AUTH_CONNECTION_NAME_PLACEHOLDER: {
    en: 'My Google Ads Connection',
    it: 'La mia connessione Google Ads',
  },
  i18n_GOOGLEADS_AUDIENCE_PARAMS_TITLE: {
    en: 'Google Ads Customer Match Configuration',
    it: 'Configurazione Customer Match di Google Ads',
  },
  i18n_GOOGLEADS_AUDIENCE_CONFIG_TITLE: {
    en: 'Audience Configuration',
    it: 'Configurazione Audience',
  },
  i18n_GOOGLEADS_DATA_CONFIG_TITLE: {
    en: 'Data Configuration',
    it: 'Configurazione Dati',
  },
  i18n_GOOGLEADS_USER_DATA_IDENTIFIER_TITLE: {
    en: 'User Data Identifier',
    it: 'Identificatore Utente',
  },
  i18n_GOOGLEADS_USER_DATA_ADDRESS_TITLE: {
    en: 'User Data Address',
    it: 'Indirizzo Utente',
  },
  i18n_GOOGLEADS_SELECT_ACCOUNT_TITLE: {
    en: 'Select Google Ads Account',
    it: 'Seleziona Account Google Ads',
  },
  i18n_GOOGLEADS_SELECT_ACCOUNT_DESCRIPTION: {
    en: 'Choose the Google Ads account where you want to create or update the audience',
    it: "Scegli l'account Google Ads in cui vuoi creare o aggiornare l'audience",
  },
  i18n_GOOGLEADS_SELECT_ACCOUNT_PLACEHOLDER: {
    en: 'Select an account',
    it: 'Seleziona un account',
  },
  i18n_GOOGLEADS_DATA_MAPPING_TITLE: {
    en: 'Data Mapping',
    it: 'Mappatura Dati',
  },
  i18n_GOOGLEADS_DATA_MAPPING_DESCRIPTION: {
    en: 'Map your audience traits to Google Ads customer match fields',
    it: 'Mappa i tuoi trait di audience ai campi customer match di Google Ads',
  },
  i18n_GOOGLEADS_AUDIENCE_TYPE_TITLE: {
    en: 'Audience Type',
    it: 'Tipo di Audience',
  },
  i18n_GOOGLEADS_NEW_AUDIENCE_NAME_TITLE: {
    en: 'New Audience Name',
    it: 'Nome Nuova Audience',
  },
  i18n_GOOGLEADS_NEW_AUDIENCE_NAME_DESCRIPTION: {
    en: 'Enter a name for the new Customer Match audience',
    it: 'Inserisci un nome per la nuova audience Customer Match',
  },
  i18n_GOOGLEADS_NEW_AUDIENCE_NAME_PLACEHOLDER: {
    en: 'My Customer Match Audience',
    it: 'La mia audience Customer Match',
  },
  i18n_GOOGLEADS_EXISTING_AUDIENCE_TITLE: {
    en: 'Select Existing Audience',
    it: 'Seleziona Audience Esistente',
  },
  i18n_GOOGLEADS_EXISTING_AUDIENCE_PLACEHOLDER: {
    en: 'Choose an existing audience',
    it: "Scegli un'audience esistente",
  },
  i18n_GOOGLEADS_SELECT_EXISTING_AUDIENCE_PLACEHOLDER: {
    en: 'Select an existing audience',
    it: "Seleziona un'audience esistente",
  },
  i18n_GOOGLEADS_SELECT_AUDIENCE_TITLE: {
    en: 'Select Audience',
    it: 'Seleziona Audience',
  },
  i18n_GOOGLEADS_SELECT_EXISTING_AUDIENCE_TITLE: {
    en: 'Select Existing Audience',
    it: 'Seleziona Audience Esistente',
  },
  i18n_COMMON_EMAIL_ADDRESS_TITLE: {
    en: 'Email Address',
    it: 'Indirizzo Email',
  },
  i18n_COMMON_EMAIL_ADDRESS_DESCRIPTION: {
    en: 'The email address of the user',
    it: "L'indirizzo email dell'utente",
  },
  i18n_COMMON_PHONE_NUMBER_TITLE: {
    en: 'Phone Number',
    it: 'Numero di Telefono',
  },
  i18n_COMMON_PHONE_NUMBER_DESCRIPTION: {
    en: 'The phone number of the user',
    it: "Il numero di telefono dell'utente",
  },
  i18n_COMMON_GIVEN_NAME_TITLE: {
    en: 'Given Name',
    it: 'Nome',
  },
  i18n_COMMON_GIVEN_NAME_DESCRIPTION: {
    en: 'The given name (first name) of the user',
    it: "Il nome dell'utente",
  },
  i18n_COMMON_FAMILY_NAME_TITLE: {
    en: 'Family Name',
    it: 'Cognome',
  },
  i18n_COMMON_FAMILY_NAME_DESCRIPTION: {
    en: 'The family name (last name) of the user',
    it: "Il cognome dell'utente",
  },
  i18n_COMMON_FIRST_NAME_TITLE: {
    en: 'First Name',
    it: 'Nome',
  },
  i18n_COMMON_LAST_NAME_TITLE: {
    en: 'Last Name',
    it: 'Cognome',
  },
  i18n_COMMON_COUNTRY_CODE_TITLE: {
    en: 'Country Code',
    it: 'Codice Paese',
  },
  i18n_COMMON_POSTAL_CODE_TITLE: {
    en: 'Postal Code',
    it: 'Codice Postale',
  },
  i18n_COMMON_POSTAL_CODE_DESCRIPTION: {
    en: "The postal or ZIP code of the user's address",
    it: "Il codice postale o CAP dell'indirizzo dell'utente",
  },
  i18n_COMMON_REGION_CODE_TITLE: {
    en: 'Region Code',
    it: 'Codice Regione',
  },
  i18n_COMMON_REGION_CODE_DESCRIPTION: {
    en: "The region or state code of the user's address",
    it: "Il codice regione o provincia dell'indirizzo dell'utente",
  },
  i18n_COMMON_SELECT_EMAIL_FIELD_PLACEHOLDER: {
    en: 'Select email field',
    it: 'Seleziona campo email',
  },
  i18n_COMMON_SELECT_PHONE_FIELD_PLACEHOLDER: {
    en: 'Select phone field',
    it: 'Seleziona campo telefono',
  },
  i18n_COMMON_SELECT_GIVEN_NAME_PLACEHOLDER: {
    en: 'Select given name field',
    it: 'Seleziona campo nome',
  },
  i18n_COMMON_SELECT_FAMILY_NAME_PLACEHOLDER: {
    en: 'Select family name field',
    it: 'Seleziona campo cognome',
  },
  i18n_COMMON_SELECT_POSTAL_CODE_PLACEHOLDER: {
    en: 'Select postal code field',
    it: 'Seleziona campo codice postale',
  },
  i18n_COMMON_SELECT_REGION_CODE_PLACEHOLDER: {
    en: 'Select region code field',
    it: 'Seleziona campo codice regione',
  },
  i18n_COMMON_MOBILE_ID_TITLE: {
    en: 'Mobile Advertising ID',
    it: 'ID Pubblicitario Mobile',
  },
  i18n_COMMON_APP_ID_TITLE: {
    en: 'App ID',
    it: 'ID App',
  },
  i18n_GOOGLEDV360_AUTH_TITLE: {
    en: 'Google DV360 Connection',
    it: 'Connessione Google DV360',
  },
  i18n_GOOGLEDV360_AUTH_DESCRIPTION: {
    en: 'Connect to Google Display & Video 360 for Customer Match audiences',
    it: 'Connettiti a Google Display & Video 360 per le audience Customer Match',
  },
  i18n_GOOGLEDV360_AUTH_CONNECTION_NAME_TITLE: {
    en: 'Connection Name',
    it: 'Nome Connessione',
  },
  i18n_GOOGLEDV360_AUTH_CONNECTION_NAME_DESCRIPTION: {
    en: 'A friendly name to identify this DV360 connection',
    it: 'Un nome descrittivo per identificare questa connessione DV360',
  },
  i18n_GOOGLEDV360_AUTH_CONNECTION_NAME_PLACEHOLDER: {
    en: 'My DV360 Connection',
    it: 'La mia connessione DV360',
  },
  i18n_GOOGLEDV360_AUDIENCE_PARAMS_TITLE: {
    en: 'Google DV360 Customer Match Configuration',
    it: 'Configurazione Customer Match di Google DV360',
  },
  i18n_GOOGLEDV360_SEAT_ID_TITLE: {
    en: 'Seat ID / Partner ID',
    it: 'ID Seat / ID Partner',
  },
  i18n_GOOGLEDV360_SEAT_ID_DESCRIPTION: {
    en: 'Enter your DV360 Seat ID (Partner ID)',
    it: 'Inserisci il tuo ID Seat DV360 (ID Partner)',
  },
  i18n_GOOGLEDV360_SEAT_ID_PLACEHOLDER: {
    en: 'Enter your Seat ID',
    it: 'Inserisci il tuo ID Seat',
  },
  i18n_GOOGLEDV360_STEP1_TITLE: {
    en: 'Enter Seat ID',
    it: 'Inserisci ID Seat',
  },
  i18n_GOOGLEDV360_STEP2_TITLE: {
    en: 'Configure Audience',
    it: 'Configura Audience',
  },
  i18n_GOOGLEDV360_AUDIENCE_NAME_TITLE: {
    en: 'Audience Name',
    it: 'Nome Audience',
  },
  i18n_GOOGLEDV360_AUDIENCE_NAME_DESCRIPTION: {
    en: 'Enter a name for the DV360 Customer Match audience',
    it: "Inserisci un nome per l'audience Customer Match DV360",
  },
  i18n_GOOGLEDV360_AUDIENCE_NAME_PLACEHOLDER: {
    en: 'My DV360 Audience',
    it: 'La mia audience DV360',
  },
  i18n_GOOGLEDV360_AUDIENCE_DESCRIPTION_TITLE: {
    en: 'Audience Description',
    it: 'Descrizione Audience',
  },
  i18n_GOOGLEDV360_AUDIENCE_DESCRIPTION_PLACEHOLDER: {
    en: 'Optional description for this audience',
    it: 'Descrizione opzionale per questa audience',
  },
  i18n_GOOGLEDV360_DATA_MAPPING_TITLE: {
    en: 'Data Mapping',
    it: 'Mappatura Dati',
  },
  i18n_GOOGLEDV360_DATA_MAPPING_DESCRIPTION: {
    en: 'Map your audience traits to DV360 customer match fields',
    it: 'Mappa i tuoi trait di audience ai campi customer match di DV360',
  },
  i18n_GOOGLEDV360_DATA_CONFIG_TITLE: {
    en: 'Data Configuration',
    it: 'Configurazione Dati',
  },
  i18n_GOOGLEDV360_USER_DATA_ADDRESS_TITLE: {
    en: 'User Data Address',
    it: 'Indirizzo Utente',
  },
  i18n_GOOGLEDV360_USER_DATA_IDENTIFIER_TITLE: {
    en: 'User Data Identifier',
    it: 'Identificatore Utente',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_PARAMS_TITLE: {
    en: 'Google Ads CMU Customer Match Configuration',
    it: 'Configurazione Customer Match di Google Ads CMU',
  },
  i18n_GOOGLEADSCMU_SEAT_ID_TITLE: {
    en: 'Seat ID / Partner ID',
    it: 'ID Seat / ID Partner',
  },
  i18n_GOOGLEADSCMU_SEAT_ID_PLACEHOLDER: {
    en: 'Enter your Seat ID',
    it: 'Inserisci il tuo ID Seat',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_NAME_TITLE: {
    en: 'Audience Name',
    it: 'Nome Audience',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_DESCRIPTION_TITLE: {
    en: 'Audience Description',
    it: 'Descrizione Audience',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_NAME_PLACEHOLDER: {
    en: 'My Google Ads CMU Audience',
    it: 'La mia audience Google Ads CMU',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_DESCRIPTION_PLACEHOLDER: {
    en: 'Optional description for this audience',
    it: 'Descrizione opzionale per questa audience',
  },
  i18n_GOOGLEADSCMU_DATA_MAPPING_TITLE: {
    en: 'Data Mapping',
    it: 'Mappatura Dati',
  },
  i18n_GOOGLEADSCMU_DATA_MAPPING_DESCRIPTION: {
    en: 'Map your audience traits to Google Ads CMU customer match fields',
    it: 'Mappa i tuoi trait di audience ai campi customer match di Google Ads CMU',
  },
  i18n_GOOGLEADSCMU_DATA_CONFIG_TITLE: {
    en: 'Data Configuration',
    it: 'Configurazione Dati',
  },
  i18n_GOOGLEADSCMU_USER_DATA_IDENTIFIER_TITLE: {
    en: 'User Data Identifier',
    it: 'Identificatore Utente',
  },
  i18n_GOOGLEADSCMU_USER_DATA_ADDRESS_TITLE: {
    en: 'User Data Address',
    it: 'Indirizzo Utente',
  },
  i18n_GOOGLEADSCMU_OAUTH_AUTH_FAILED: {
    en: 'Google Ads CMU OAuth authentication failed',
    it: 'Autenticazione OAuth di Google Ads CMU fallita',
  },
  i18n_GOOGLEADSCMU_FLOW_PREPARE_STEP_REQUIRED: {
    en: 'Prepare with step is required',
    it: 'È richiesta la preparazione con lo step',
  },
  i18n_GOOGLEADSCMU_SEAT_ID_NOT_CONFIGURED: {
    en: 'Seat ID is not configured',
    it: "L'ID Seat non è configurato",
  },
  i18n_GOOGLEADSCMU_SEAT_NOT_LINKED: {
    en: 'This seat is not linked to Audiencerate, please go in DV360 and link Audiencerate',
    it: 'Questo seat non è collegato ad Audiencerate, vai in DV360 e collega Audiencerate',
  },
  i18n_GOOGLEADSCMU_FLOW_PREPARE_FAILED: {
    en: 'Failed to prepare Google Ads CMU Customer Match flow',
    it: 'Impossibile preparare il flusso Customer Match di Google Ads CMU',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_NAME_NOT_CONFIGURED: {
    en: 'Audience Name is not configured',
    it: "Il nome dell'audience non è configurato",
  },
  i18n_GOOGLEADSCMU_AUDIENCE_TRANSFER_FAILED: {
    en: 'Google Ads CMU audience transfer failed',
    it: 'Trasferimento audience Google Ads CMU fallito',
  },
  i18n_GOOGLEADSCMU_AUDIENCE_TRANSFER_FAILED_UNEXPECTED: {
    en: 'Google Ads CMU audience transfer failed due to unexpected error',
    it: 'Trasferimento audience Google Ads CMU fallito a causa di un errore imprevisto',
  },
  i18n_SEIWEB_AUTH_TITLE: {
    en: 'Sei Web Authentication',
    it: 'Autenticazione Sei Web',
  },
  i18n_SEIWEB_AUTH_DESCRIPTION: {
    en: 'Enter your Sei Web credentials to connect',
    it: 'Inserisci le tue credenziali Sei Web per connetterti',
  },
  i18n_SEIWEB_AUTH_USERNAME_PLACEHOLDER: {
    en: 'Username',
    it: 'Username',
  },
  i18n_SEIWEB_AUTH_PASSWORD_PLACEHOLDER: {
    en: 'Password',
    it: 'Password',
  },
  i18n_COMMON_USERNAME_TITLE: {
    en: 'Username',
    it: 'Nome Utente',
  },
  i18n_COMMON_USERNAME_PLACEHOLDER: {
    en: 'Enter your username',
    it: 'Inserisci il tuo nome utente',
  },
  i18n_COMMON_PASSWORD_TITLE: {
    en: 'Password',
    it: 'Password',
  },
  i18n_COMMON_PASSWORD_PLACEHOLDER: {
    en: 'Enter your password',
    it: 'Inserisci la tua password',
  },
  i18n_COMMON_PORT_TITLE: {
    en: 'Port',
    it: 'Porta',
  },
  i18n_SEIWEB_UPLOAD_PARAMS_TITLE: {
    en: 'Sei Web Upload Configuration',
    it: 'Configurazione Upload Sei Web',
  },
  i18n_SEIWEB_FILENAME_TITLE: {
    en: 'File Name',
    it: 'Nome File',
  },
  i18n_SEIWEB_FILENAME_DESCRIPTION: {
    en: 'Name of the file to upload',
    it: 'Nome del file da caricare',
  },
  i18n_SEIWEB_FILENAME_PLACEHOLDER: {
    en: 'seiweb-upload.csv',
    it: 'seiweb-upload.csv',
  },
  i18n_SEIWEB_DATA_MAPPING_TITLE: {
    en: 'Data Mapping',
    it: 'Mappatura Dati',
  },
  i18n_SEIWEB_DATA_MAPPING_DESCRIPTION: {
    en: 'Select a template and map your data fields',
    it: 'Seleziona un template e mappa i tuoi campi dati',
  },
  i18n_SEIWEB_TEMPLATE_TITLE: {
    en: 'Template',
    it: 'Template',
  },
  i18n_SEIWEB_TEMPLATE_PLACEHOLDER: {
    en: 'Select a template',
    it: 'Seleziona un template',
  },
  i18n_SEIWEB_TRAIT_MAPPING_DESCRIPTION: {
    en: 'Trait to map with the Sei Web field: ',
    it: 'Caratteristica da mappare con il campo Sei Web: ',
  },
  i18n_MAPPSFTPLBA_AUTH_TITLE: {
    en: 'Mapp SFTP LBA Connection',
    it: 'Connessione Mapp SFTP LBA',
  },
  i18n_MAPPSFTPLBA_AUTH_DESCRIPTION: {
    en: 'Enter your Mapp SFTP LBA server details and SSH key authentication credentials',
    it: 'Inserisci i dettagli del server Mapp SFTP LBA e le credenziali di autenticazione SSH',
  },
  i18n_MAPPSFTPLBA_SERVER_HOST_TITLE: {
    en: 'Server Host',
    it: 'Host Server',
  },
  i18n_MAPPSFTPLBA_SERVER_HOST_DESCRIPTION: {
    en: 'Mapp SFTP LBA server hostname or IP address',
    it: 'Nome host o indirizzo IP del server Mapp SFTP LBA',
  },
  i18n_MAPPSFTPLBA_SERVER_HOST_PLACEHOLDER: {
    en: 'sftp.y-tech.it',
    it: 'sftp.y-tech.it',
  },
  i18n_MAPPSFTPLBA_PORT_PLACEHOLDER: {
    en: '8022',
    it: '8022',
  },
  i18n_MAPPSFTPLBA_USERNAME_PLACEHOLDER: {
    en: 'lba_audiencerate',
    it: 'lba_audiencerate',
  },
  i18n_MAPPSFTPLBA_AUTH_METHOD_TITLE: {
    en: 'Authentication Method',
    it: 'Metodo di Autenticazione',
  },
  i18n_MAPPSFTPLBA_BASE_PATH_TITLE: {
    en: 'Base Path',
    it: 'Percorso Base',
  },
  i18n_MAPPSFTPLBA_BASE_PATH_DESCRIPTION: {
    en: 'Default directory path (optional)',
    it: 'Percorso directory predefinito (opzionale)',
  },
  i18n_MAPPSFTPLBA_BASE_PATH_PLACEHOLDER: {
    en: '/uploads or /data',
    it: '/uploads o /data',
  },
  i18n_MAPPSFTPLBA_PRIVATE_KEY_TITLE: {
    en: 'Private Key',
    it: 'Chiave Privata',
  },
  i18n_MAPPSFTPLBA_PRIVATE_KEY_DESCRIPTION: {
    en: 'SSH private key for authentication',
    it: "Chiave privata SSH per l'autenticazione",
  },
  i18n_MAPPSFTPLBA_PRIVATE_KEY_PLACEHOLDER: {
    en: '-----BEGIN OPENSSH PRIVATE KEY-----\n...\n-----END OPENSSH PRIVATE KEY-----',
    it: '-----BEGIN OPENSSH PRIVATE KEY-----\n...\n-----END OPENSSH PRIVATE KEY-----',
  },
  i18n_MAPPSFTPLBA_KEY_PASSPHRASE_TITLE: {
    en: 'Key Passphrase',
    it: 'Passphrase Chiave',
  },
  i18n_MAPPSFTPLBA_KEY_PASSPHRASE_DESCRIPTION: {
    en: 'Passphrase for the private key (if encrypted)',
    it: 'Passphrase per la chiave privata (se crittografata)',
  },
  i18n_MAPPSFTPLBA_PASSWORD_DESCRIPTION: {
    en: 'Password for SSH authentication',
    it: "Password per l'autenticazione SSH",
  },
  i18n_MAPPSFTPLBA_PASSWORD_PLACEHOLDER: {
    en: 'Enter your SSH password',
    it: 'Inserisci la tua password SSH',
  },
  i18n_MAPPSFTPLBA_PASSPHRASE_HELP: {
    en: 'Leave empty if key is not encrypted',
    it: 'Lascia vuoto se la chiave non è crittografata',
  },
  i18n_MAPPSFTPLBA_PARAMS_TITLE: {
    en: 'Mapp SFTP LBA Export Configuration',
    it: 'Configurazione Export Mapp SFTP LBA',
  },
  i18n_MAPPSFTPLBA_CSV_FILENAME_TITLE: {
    en: 'CSV Filename',
    it: 'Nome File CSV',
  },
  i18n_MAPPSFTPLBA_CSV_FILENAME_DESCRIPTION: {
    en: 'Name of the CSV file to upload',
    it: 'Nome del file CSV da caricare',
  },
  i18n_MAPPSFTPLBA_CSV_FILENAME_PLACEHOLDER: {
    en: 'Mapp_import_related_data.csv',
    it: 'Mapp_import_related_data.csv',
  },
  i18n_MAPPSFTPLBA_DIRECTORY_PATH_TITLE: {
    en: 'Directory Path',
    it: 'Percorso Directory',
  },
  i18n_MAPPSFTPLBA_DIRECTORY_PATH_DESCRIPTION: {
    en: 'Remote directory path for file upload',
    it: 'Percorso directory remoto per il caricamento file',
  },
  i18n_MAPPSFTPLBA_DIRECTORY_PATH_PLACEHOLDER: {
    en: '/data',
    it: '/data',
  },
  i18n_MAPPSFTPLBA_MAPPING_TITLE: {
    en: 'Data Mapping',
    it: 'Mappatura Dati',
  },
  i18n_MAPPSFTPLBA_MAPPING_DESCRIPTION: {
    en: 'Configure how your data is mapped to the Mapp format',
    it: 'Configura come i tuoi dati vengono mappati nel formato Mapp',
  },
  i18n_GOOGLEDV360_FLOW_PREPARE_STEP_REQUIRED: {
    en: 'Prepare with step is required',
    it: 'È richiesta la preparazione con lo step',
  },
  i18n_COMMON_FLOW_CONFIG_REQUIRED: {
    en: 'Flow configuration is required for preparation',
    it: 'La configurazione del flusso è richiesta per la preparazione',
  },
  i18n_COMMON_CREDENTIALS_REQUIRED_FOR_PREPARATION: {
    en: 'Connector credentials are required for flow preparation',
    it: 'Le credenziali del connettore sono richieste per la preparazione del flusso',
  },
  i18n_GOOGLEDV360_SEAT_ID_NOT_CONFIGURED: {
    en: 'Seat ID is not configured',
    it: "L'ID Seat non è configurato",
  },
  i18n_COMMON_MISSING_DATA_MANAGER_CLIENT_ID: {
    en: 'Cannot get credentials: data_manager_client_id is missing',
    it: 'Impossibile ottenere le credenziali: data_manager_client_id mancante',
  },
  i18n_COMMON_MISSING_DATA_MANAGER_CLIENT_SECRET: {
    en: 'Cannot get credentials: data_manager_client_secret is missing',
    it: 'Impossibile ottenere le credenziali: data_manager_client_secret mancante',
  },
  i18n_COMMON_MISSING_DATA_MANAGER_REFRESH_TOKEN: {
    en: 'Cannot get credentials: data_manager_refresh_token is missing',
    it: 'Impossibile ottenere le credenziali: data_manager_refresh_token mancante',
  },
  i18n_GOOGLEDV360_SEAT_NOT_LINKED: {
    en: 'This seat is not linked to Audiencerate, please go in DV360 and link Audiencerate',
    it: 'Questo seat non è collegato ad Audiencerate, vai in DV360 e collega Audiencerate',
  },
  i18n_COMMON_STEP_NOT_RECOGNIZED: {
    en: 'Step not recognized',
    it: 'Step non riconosciuto',
  },
  i18n_GOOGLEDV360_FLOW_PREPARE_FAILED: {
    en: 'Failed to prepare Google DV360 Customer Match flow',
    it: 'Impossibile preparare il flusso Customer Match di Google DV360',
  },
  i18n_COMMON_CREDENTIALS_REQUIRED_FOR_SENDING: {
    en: 'Connector credentials are required for data sending',
    it: "Le credenziali del connettore sono richieste per l'invio dei dati",
  },
  i18n_GOOGLEDV360_AUDIENCE_NAME_NOT_CONFIGURED: {
    en: 'Audience Name is not configured',
    it: "Il nome dell'audience non è configurato",
  },
  i18n_COMMON_BATCH_PROCESSING_FAILED: {
    en: 'Batch processing failed due to unexpected error',
    it: "L'elaborazione batch è fallita a causa di un errore imprevisto",
  },
  i18n_GOOGLEDV360_AUDIENCE_TRANSFER_FAILED: {
    en: 'Google DV360 audience transfer failed',
    it: 'Trasferimento audience Google DV360 fallito',
  },
  i18n_GOOGLEDV360_AUDIENCE_TRANSFER_FAILED_UNEXPECTED: {
    en: 'Google DV360 audience transfer failed due to unexpected error',
    it: 'Trasferimento audience Google DV360 fallito a causa di un errore imprevisto',
  },
  i18n_COMMON_CANNOT_REFRESH_TOKEN: {
    en: 'Cannot refresh token',
    it: 'Impossibile aggiornare il token',
  },
  i18n_GOOGLEADS_FLOW_PREPARE_FAILED: {
    en: 'Failed to prepare Google Ads Customer Match flow',
    it: 'Impossibile preparare il flusso Customer Match di Google Ads',
  },
  i18n_GOOGLEADS_FLOW_PREPARE_AUDIENCE_FAILED: {
    en: 'Failed to prepare Google Ads Customer Match flow for audience',
    it: "Impossibile preparare il flusso Customer Match di Google Ads per l'audience",
  },
  i18n_GOOGLEADS_ACCOUNT_REQUIRED: {
    en: 'Google Ads account is required for data sending',
    it: "È richiesto un account Google Ads per l'invio dei dati",
  },
  i18n_GOOGLEADS_AUDIENCE_TYPE_REQUIRED: {
    en: 'Audience type is required for data sending',
    it: "È richiesto il tipo di audience per l'invio dei dati",
  },
  i18n_GOOGLEADS_NEW_AUDIENCE_NAME_REQUIRED: {
    en: 'New audience name is required for new audience creation',
    it: 'È richiesto un nome per la creazione di una nuova audience',
  },
  i18n_GOOGLEADS_EXISTING_AUDIENCE_REQUIRED: {
    en: 'Existing audience selection is required',
    it: "È richiesta la selezione di un'audience esistente",
  },
  i18n_GOOGLEADS_AUDIENCE_TYPE_INVALID: {
    en: 'Audience type has an unexpected value',
    it: 'Il tipo di audience ha un valore imprevisto',
  },
  i18n_GOOGLEADS_AUDIENCE_TRANSFER_FAILED: {
    en: 'Google Ads audience transfer failed',
    it: 'Trasferimento audience Google Ads fallito',
  },
  i18n_GOOGLEADS_AUDIENCE_TRANSFER_FAILED_UNEXPECTED: {
    en: 'Google Ads audience transfer failed due to unexpected error',
    it: 'Trasferimento audience Google Ads fallito a causa di un errore imprevisto',
  },
  i18n_MAPPSFTPLBA_AUDIENCE_EXPORT_FAILED: {
    en: 'Mapp SFTP LBA audience export failed due to unexpected error',
    it: 'Esportazione audience Mapp SFTP LBA fallita a causa di un errore imprevisto',
  },
  i18n_MAPPSFTPLBA_CSV_GENERATION_FAILED: {
    en: 'Failed to generate Mapp CSV content',
    it: 'Impossibile generare il contenuto CSV di Mapp',
  },
  i18n_MAPPSFTPLBA_UPLOAD_FAILED: {
    en: 'Failed to upload Mapp CSV file to SFTP server',
    it: 'Impossibile caricare il file CSV di Mapp sul server SFTP',
  },
  i18n_MAPPSFTPLBA_INVALID_CREDENTIALS_FORMAT: {
    en: 'Invalid SFTP credentials format',
    it: 'Formato credenziali SFTP non valido',
  },
  i18n_SEIWEB_MISSING_AUTH_SECRETS: {
    en: 'Missing required auth secrets for Sei Web authentication',
    it: 'Segreti di autenticazione richiesti per Sei Web mancanti',
  },
  i18n_COMMON_CANNOT_REFRESH_CREDENTIALS: {
    en: 'Cannot refresh credentials',
    it: 'Impossibile aggiornare le credenziali',
  },
  i18n_COMMON_MISSING_REFRESHED_CREDENTIALS: {
    en: 'Missing refreshed credentials from connector',
    it: 'Credenziali aggiornate dal connettore mancanti',
  },
  i18n_SEIWEB_MISSING_TRAITS_OR_PROPERTIES: {
    en: 'Missing traits or custom properties, unable to prepare Sei Web flow',
    it: 'Trait o proprietà personalizzate mancanti, impossibile preparare il flusso Sei Web',
  },
  i18n_SEIWEB_UNABLE_TO_GET_TEMPLATES: {
    en: 'Unable to get templates from Sei Web',
    it: 'Impossibile ottenere i template da Sei Web',
  },
  i18n_GOOGLEADS_OAUTH_PARAMS_REQUIRED: {
    en: 'OAuth parameters are required for Google Ads authentication',
    it: "I parametri OAuth sono richiesti per l'autenticazione Google Ads",
  },
  i18n_GOOGLEADS_OAUTH_AUTH_FAILED: {
    en: 'Google Ads OAuth authentication failed',
    it: 'Autenticazione OAuth di Google Ads fallita',
  },
  i18n_GOOGLEADS_CREDENTIALS_REQUIRED_FOR_CONNECTION_TEST: {
    en: 'Credentials are required for Google Ads connection test',
    it: 'Le credenziali sono richieste per il test di connessione Google Ads',
  },
  i18n_GOOGLEADS_ACCESS_TOKEN_REQUIRED: {
    en: 'Access token is required in credentials',
    it: 'È richiesto un access token nelle credenziali',
  },
  i18n_GOOGLEADS_CONNECTION_TEST_FAILED: {
    en: 'Google Ads connection test failed',
    it: 'Test di connessione Google Ads fallito',
  },
  i18n_GOOGLEADS_CONNECTION_TEST_FAILED_UNEXPECTED: {
    en: 'Google Ads connection test failed due to unexpected error',
    it: 'Test di connessione Google Ads fallito a causa di un errore imprevisto',
  },
  i18n_COMMON_CONNECTOR_INSTANCE_REQUIRED_FOR_REFRESH: {
    en: 'Connector instance is required for credential refresh',
    it: "È richiesta un'istanza del connettore per l'aggiornamento delle credenziali",
  },
  i18n_GOOGLEADS_REFRESH_TOKEN_MISSING: {
    en: 'Refresh token is missing from stored credentials',
    it: 'Il refresh token è mancante dalle credenziali memorizzate',
  },
  i18n_GOOGLEADS_TOKEN_REFRESH_FAILED: {
    en: 'Google Ads token refresh failed',
    it: 'Aggiornamento token Google Ads fallito',
  },
  i18n_GOOGLEADS_CREDENTIAL_REFRESH_FAILED_UNEXPECTED: {
    en: 'Google Ads credential refresh failed due to unexpected error',
    it: 'Aggiornamento credenziali Google Ads fallito a causa di un errore imprevisto',
  },
  i18n_GOOGLEADS_MISSING_OAUTH_PARAMS: {
    en: 'Missing required OAuth parameters: client_id, redirect_uri, or state',
    it: 'Parametri OAuth richiesti mancanti: client_id, redirect_uri o state',
  },
  i18n_GOOGLEADS_OAUTH_FLOW_INIT_FAILED: {
    en: 'Failed to initiate Google Ads OAuth flow',
    it: 'Impossibile avviare il flusso OAuth di Google Ads',
  },
  i18n_GOOGLEADS_TOKEN_EXCHANGE_FAILED: {
    en: 'Google Ads token exchange failed',
    it: 'Scambio token Google Ads fallito',
  },
  i18n_GOOGLEADS_TOKEN_RESPONSE_MISSING_ACCESS_TOKEN: {
    en: 'Google Ads token response missing access_token',
    it: 'Risposta token Google Ads senza access_token',
  },
  i18n_GOOGLEADS_OAUTH_CALLBACK_FAILED: {
    en: 'Google Ads OAuth callback handling failed',
    it: 'Gestione callback OAuth di Google Ads fallita',
  },
  i18n_GOOGLEDV360_OAUTH_AUTH_FAILED: {
    en: 'Google DV360 OAuth authentication failed',
    it: 'Autenticazione OAuth di Google DV360 fallita',
  },
  i18n_SEIWEB_AUTH_PARAMS_REQUIRED: {
    en: 'Sei Web auth params are required for authentication',
    it: 'I parametri di autenticazione Sei Web sono richiesti',
  },
  i18n_SEIWEB_MISSING_AUTH_PARAMS: {
    en: 'Missing required auth params for Sei Web authentication',
    it: 'Parametri di autenticazione richiesti per Sei Web mancanti',
  },
  i18n_SEIWEB_CREDENTIALS_REQUIRED_FOR_CONNECTION_TEST: {
    en: 'Sei Web credentials are required for connection test',
    it: 'Le credenziali Sei Web sono richieste per il test di connessione',
  },
  i18n_SEIWEB_MISSING_AUTH_SECRETS_CONNECTION_TEST: {
    en: 'Missing required auth secrets for Sei Web connection test',
    it: 'Segreti di autenticazione richiesti per il test di connessione Sei Web mancanti',
  },
  i18n_SEIWEB_MISSING_AUTH_PARAMS_CONNECTION_TEST: {
    en: 'Missing required auth params for Sei Web connection test',
    it: 'Parametri di autenticazione richiesti per il test di connessione Sei Web mancanti',
  },
  i18n_SEIWEB_CREDENTIALS_REQUIRED_FOR_REFRESH: {
    en: 'Sei Web credentials are required for refresh',
    it: "Le credenziali Sei Web sono richieste per l'aggiornamento",
  },
  i18n_SEIWEB_MISSING_REFRESH_TOKEN: {
    en: 'Missing required refresh token for Sei Web refresh',
    it: "Refresh token richiesto per l'aggiornamento Sei Web mancante",
  },
  i18n_SEIWEB_MISSING_AUTH_SECRETS_REFRESH: {
    en: 'Missing required auth secrets for Sei Web refresh',
    it: "Segreti di autenticazione richiesti per l'aggiornamento Sei Web mancanti",
  },
  i18n_SEIWEB_AUTHENTICATION_FAILED: {
    en: 'Unable to authenticate Sei Web connector',
    it: 'Autenticazione del connettore Sei Web fallita',
  },
  i18n_SEIWEB_REFRESH_FAILED: {
    en: 'Unable to refresh Sei Web token',
    it: 'Refresh del token di Sei Web fallita',
  },
  I18N_SEIWEB_UNABLE_TO_GET_MAPPINGS: {
    en: 'Unable to get mappings from Sei Web',
    it: 'Impossibile ottenere le mappature da Sei Web',
  },
  i18n_MAPPSFTPLBA_SFTP_PARAMS_REQUIRED: {
    en: 'SFTP parameters are required for authentication',
    it: "I parametri SFTP sono richiesti per l'autenticazione",
  },
  i18n_MAPPSFTPLBA_MISSING_SFTP_PARAMS: {
    en: 'Missing required SFTP connection parameters: host, username, and either private_key or password',
    it: 'Parametri di connessione SFTP richiesti mancanti: host, username e private_key o password',
  },
  i18n_MAPPSFTPLBA_PASSWORD_OR_KEY_REQUIRED: {
    en: 'Either password or private key is required for authentication',
    it: "È richiesta una password o una chiave privata per l'autenticazione",
  },
  i18n_MAPPSFTPLBA_SFTP_CONNECTION_TEST_FAILED: {
    en: 'SFTP connection test failed',
    it: 'Test di connessione SFTP fallito',
  },
  i18n_MAPPSFTPLBA_AUTH_FAILED_UNEXPECTED: {
    en: 'Mapp SFTP LBA authentication failed due to unexpected error',
    it: 'Autenticazione Mapp SFTP LBA fallita a causa di un errore imprevisto',
  },
  i18n_MAPPSFTPLBA_CREDENTIALS_REQUIRED_FOR_CONNECTION_TEST: {
    en: 'Credentials are required for SFTP connection test',
    it: 'Le credenziali sono richieste per il test di connessione SFTP',
  },
  i18n_MAPPSFTPLBA_CONNECTION_TEST_FAILED: {
    en: 'Mapp SFTP LBA connection test failed',
    it: 'Test di connessione Mapp SFTP LBA fallito',
  },
  i18n_MAPPSFTPLBA_CONNECTION_TEST_FAILED_UNEXPECTED: {
    en: 'Mapp SFTP LBA connection test failed due to unexpected error',
    it: 'Test di connessione Mapp SFTP LBA fallito a causa di un errore imprevisto',
  },
  i18n_MAPPSFTPLBA_CREDENTIAL_VALIDATION_FAILED: {
    en: 'Mapp SFTP LBA credential validation failed',
    it: 'Validazione credenziali Mapp SFTP LBA fallita',
  },
  i18n_MAPPSFTPLBA_CREDENTIAL_REFRESH_FAILED_UNEXPECTED: {
    en: 'Mapp SFTP LBA credential refresh failed due to unexpected error',
    it: 'Aggiornamento credenziali Mapp SFTP LBA fallito a causa di un errore imprevisto',
  },
};
